import { render, staticRenderFns } from "./tennis_common.vue?vue&type=template&id=e6406678"
import script from "./tennis_common.vue?vue&type=script&lang=js"
export * from "./tennis_common.vue?vue&type=script&lang=js"
import style0 from "./tennis_common.vue?vue&type=style&index=0&id=e6406678&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports